var _g, _defs;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExcelLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_508_6222)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.3872 0.951322C17.2401 0.831813 17.0464 0.786126 16.8614 0.827338L0.740967 4.54745C0.45725 4.61267 0.257061 4.86645 0.259793 5.15755V26.2382C0.25991 26.5441 0.483174 26.8043 0.78555 26.8508L16.906 29.3309C17.2445 29.3829 17.561 29.1508 17.6131 28.8123C17.6178 28.7812 17.6203 28.7498 17.6203 28.7184V1.43744C17.6209 1.24835 17.535 1.06938 17.3872 0.951322Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4013 26.858H17.0009C16.6585 26.858 16.3809 26.5804 16.3809 26.238C16.3809 25.8955 16.6585 25.6179 17.0009 25.6179H28.7813V4.53732H17.0009C16.6585 4.53732 16.3809 4.25971 16.3809 3.91728C16.3809 3.57486 16.6585 3.2973 17.0009 3.2973H29.4013C29.7437 3.2973 30.0213 3.57492 30.0213 3.91734V26.238C30.0213 26.5804 29.7437 26.858 29.4013 26.858Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0438 20.6579C11.83 20.6579 11.6314 20.5477 11.5181 20.3665L5.31787 10.4461C5.12727 10.1617 5.20341 9.77653 5.48789 9.58593C5.77236 9.39533 6.15751 9.47148 6.3481 9.75595C6.3556 9.76711 6.36269 9.77851 6.36944 9.79013L12.5696 19.7105C12.7504 20.0013 12.6613 20.3836 12.3704 20.5644C12.2724 20.6253 12.1593 20.6577 12.0438 20.6579Z",
    fill: "#033F9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.84337 20.658C5.50095 20.6573 5.22391 20.3792 5.22461 20.0368C5.22484 19.921 5.25751 19.8076 5.31883 19.7094L11.519 9.78908C11.6907 9.49281 12.0701 9.39184 12.3664 9.56355C12.6626 9.73525 12.7636 10.1146 12.5919 10.4109C12.5851 10.4225 12.5781 10.4339 12.5706 10.445L6.37041 20.3654C6.25717 20.5475 6.05786 20.6582 5.84337 20.658Z",
    fill: "#033F9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9613 26.8581C21.6189 26.8581 21.3413 26.5804 21.3413 26.238V3.91734C21.3413 3.57492 21.6189 3.2973 21.9613 3.2973C22.3038 3.2973 22.5814 3.57492 22.5814 3.91734V26.238C22.5813 26.5805 22.3038 26.8581 21.9613 26.8581Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4008 23.138H17.0004C16.658 23.138 16.3804 22.8604 16.3804 22.5179C16.3804 22.1755 16.658 21.8979 17.0004 21.8979H29.4008C29.7432 21.8979 30.0208 22.1755 30.0208 22.5179C30.0208 22.8604 29.7432 23.138 29.4008 23.138Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4008 19.4178H17.0004C16.658 19.4178 16.3804 19.1402 16.3804 18.7978C16.3804 18.4553 16.658 18.1777 17.0004 18.1777H29.4008C29.7432 18.1777 30.0208 18.4553 30.0208 18.7978C30.0208 19.1403 29.7432 19.4178 29.4008 19.4178Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4008 15.6976H17.0004C16.658 15.6976 16.3804 15.42 16.3804 15.0776C16.3804 14.7351 16.658 14.4575 17.0004 14.4575H29.4008C29.7432 14.4575 30.0208 14.7351 30.0208 15.0776C30.0208 15.42 29.7432 15.6976 29.4008 15.6976Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4008 11.9777H17.0004C16.658 11.9777 16.3804 11.7001 16.3804 11.3576C16.3804 11.0152 16.658 10.7376 17.0004 10.7376H29.4008C29.7432 10.7376 30.0208 11.0152 30.0208 11.3576C30.0208 11.7001 29.7432 11.9777 29.4008 11.9777Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4008 8.25753H17.0004C16.658 8.25753 16.3804 7.97992 16.3804 7.63749C16.3804 7.29507 16.658 7.01746 17.0004 7.01746H29.4008C29.7432 7.01746 30.0208 7.29507 30.0208 7.63749C30.0208 7.97998 29.7432 8.25753 29.4008 8.25753Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_508_6222"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29.7609,
    height: 29.7609,
    fill: "white",
    transform: "translate(0.259766 0.194824)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcelLogo);
export default __webpack_public_path__ + "static/media/Excel-logo.0bb1307f6f082cd696bb5567bd0c3120.svg";
export { ForwardRef as ReactComponent };